var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5450",
    "data-name": "Group 5450",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.75,
    height: 23.686,
    viewBox: "0 0 16.75 23.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M14.3,2.453A8.366,8.366,0,0,0,1.1,12.495c.006.015.013.03.02.044L7.933,23.42a.5.5,0,0,0,.885,0l6.814-10.881a.446.446,0,0,0,.022-.05A8.336,8.336,0,0,0,14.3,2.453",
    fill: "#334A7C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5449",
    "data-name": "Group 5449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M3.73,11.269h9.29V4.053H3.73Zm6.6-3.108H8.875V9.615h-1V8.161H6.422v-1H7.875V5.708h1V7.161h1.454Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.a38e7ddb3069622a6b386eb1ebd214d9.svg";
export { ForwardRef as ReactComponent };